import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-five',
  templateUrl: './demo-five.component.html',
  styleUrls: ['./demo-five.component.scss']
})
export class DemoFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
